import { productSearch } from './product-search.i18n';

export const de = {
  productSearch,
};
